/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import clsx from "clsx";
import loadable from "@loadable/component";
import { motion } from "framer-motion";
import UiContext from "@UiContext";

import styles from "./DesktopMenu.styles";

const ReactLink = loadable(() => import("@micado-digital/react-link/ReactLink"));
const ClickAwayListener = loadable(() => import("@material-ui/core/ClickAwayListener"));

const DesktopMenu = ({ items }) => {
	const css = styles();
	const [menuIDVisible, setMenuIDVisible] = useState(null);
	const [ui, setUi] = useContext(UiContext);
	const { desktopMenuOpen } = ui;

	const handleClick = (e, id) => {
		e.preventDefault();

		if (id === menuIDVisible) {
			setMenuIDVisible(null);
			return;
		}

		setMenuIDVisible(id);
	};

	const handleClickAway = () => {
		setMenuIDVisible(null);
	};

	useEffect(() => {
		if (menuIDVisible) {
			setUi(prevState => ({ ...prevState, desktopMenuOpen: true }));
		} else {
			setUi(prevState => ({ ...prevState, desktopMenuOpen: false }));
		}
	}, [menuIDVisible]);

	useEffect(() => {
		if (!desktopMenuOpen && menuIDVisible > 0) {
			setMenuIDVisible(null);
		}
	}, [desktopMenuOpen]);

	return (
		<div className={clsx(css.desktopMenu, "mco-view-component-header-desktop-menu")}>
			{items?.map(item => {
				const { id, items, link, linkRel, selected, target, title } = item;

				const currentVisible = menuIDVisible === id;
				const hasChildren = items && items.length > 0;

				return (
					<motion.div
						animate={{ opacity: 1, x: 0 }}
						className={clsx(css.level1, "mco-view-component-header-desktop-menu__level1")}
						initial={{ opacity: 0, x: -16 }}
						key={id}
						transition={{
							delay: 0.8,
							duration: 0.45,
							ease: [0, 0.71, 0.2, 1.01]
						}}
					>
						<ReactLink
							className={clsx(css.link, "mco-view-component-header-desktop-menu__link", {
								[css.linkSelected]: selected,
								[css.linkCurrent]: currentVisible,
								[css.linkOther]: menuIDVisible && id !== menuIDVisible
							})}
							dangerouslySetInnerHTML={{ __html: title }}
							onClick={e => hasChildren && handleClick(e, id)}
							rel={linkRel ? linkRel : ""}
							target={target}
							to={link}
						></ReactLink>
						{currentVisible && (
							<ClickAwayListener onClickAway={handleClickAway}>
								<motion.div
									animate={{ opacity: 1, y: 0 }}
									className={clsx(
										css.subList,
										"mco-view-component-header-desktop-menu__sub-list"
									)}
									initial={{ opacity: 0, y: -16 }}
									transition={{
										duration: 0.45
									}}
								>
									{items?.map(item => {
										const { id, link, linkRel, selected, target, title } = item;

										return (
											<ReactLink
												className={clsx(
													css.link2,
													"mco-view-component-header-desktop-menu__link2",
													{
														[css.link2Selected]: selected
													}
												)}
												dangerouslySetInnerHTML={{ __html: title }}
												key={id}
												rel={linkRel ? linkRel : ""}
												target={target}
												to={link}
											/>
										);
									})}
								</motion.div>
							</ClickAwayListener>
						)}
					</motion.div>
				);
			})}
		</div>
	);
};

export default DesktopMenu;
